import React from 'react'

const Badge = (props) => {
  return (
    <button
        type='button'
        style={{ cursor: 'pointer', border: '1px solid #F95E2F' }}
        className={`badge badge-${props.variant} p-4 me-2 me-md-3 rounded-pill text-${props.color}`}
        onClick={props.onClick}
    >
        {props.label}
    </button>
  )
}

export default Badge